import { CAMUNDA_URL } from '@/core/config';
import { server } from '../core/server/axios';
import { VariableFilter } from './CamundaController';
import i18n from '@/i18nextConf';

export class QuerySave {
  id = 0;
  queueId = 0;
  name: string = i18n.t("newrequest");
  username = "";
  filter: Array<VariableFilter> = [];
  public constructor(init?: Partial<QuerySave>) {
    Object.assign(this, init);
  }
}

export class QueryController {

  async create(query: QuerySave): Promise<any> {
    return await server.post(`/sonata/api/query`, query, {
      baseURL: CAMUNDA_URL
    });
  }

  async get(id: number): Promise<QuerySave> {
    return await server.get(`/sonata/api/query/${id}`, {
      baseURL: CAMUNDA_URL
    });
  }

  async delete(id: number) {
    return await server.delete(`/sonata/api/query/${id}`, {
      baseURL: CAMUNDA_URL
    });
  }

  async getUserQueries(
    username: string,
    queueId: number
  ): Promise<Array<QuerySave>> {
    return server.get(
      `/sonata/api/query/user/${username}/queue/${queueId}`, {
      baseURL: CAMUNDA_URL
    });
  }
}
